module.exports = __webpack_public_path__ + "static/media/gpleiss_thesis.d218bc00.pdf";